<template>
  <el-dialog
      :visible.sync="visible"
      title="确认付款"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        :inline="true"
        :model="dataForm"
    >
      <el-form-item prop="payType" label="付款方式：">
        <el-input v-model="dataForm.payType" size="medium" clearable type="text"
                  placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="payTime" label="付款时间：">
        <el-date-picker type="date" v-model="dataForm.payTime" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="batchSet" size="medium">批量设置</el-button>
      </el-form-item>
    </el-form>
    <vxe-table
        border
        show-footer
        show-overflow
        ref="xTable"
        :data="dataList"
        max-height="500"
        :ref="tableConfig.tableName"
        :footer-method="tableFooter"
        :edit-rules="validRules"
        :edit-config="{trigger: 'manual', mode: 'row'}">
      <vxe-column type="seq" title="行号" width="50"></vxe-column>
      <vxe-column field="receiptCode" title="发票号">
      </vxe-column>
      <vxe-column field="sellerName" title="付款对象" :formatter="companyNameFormatter">
      </vxe-column>
      <vxe-column field="totalAmount" width="90" title="发票金额">
      </vxe-column>
      <vxe-column field="payedAmount" width="90" title="已付款">
      </vxe-column>
      <vxe-column field="unPayAmount" width="90" title="未付款">
      </vxe-column>
      <vxe-column field="payType" title="付款方式">
        <template #default="{ row }">
          <vxe-input v-model="row.payType" placeholder="付款方式"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="payNo" title="付款凭证号">
        <template #default="{ row }">
          <vxe-input v-model="row.payNo" placeholder="请输入付款凭证号"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="payAmount" title="付款金额">
        <template #default="{ row }">
          <vxe-input v-model="row.payAmount" placeholder="请输入付款金额" @input="updateFooterEvent"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="payTime" width="180" title="付款时间">
        <template #default="{ row }">
          <el-date-picker type="date" v-model="row.payTime" style="width: 140px;"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </template>
      </vxe-column>
      <vxe-column field="remark" title="用途备注">
        <template #default="{ row }">
          <vxe-input v-model="row.remark" placeholder="请输入用途备注"></vxe-input>
        </template>
      </vxe-column>
    </vxe-table>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import VxeTable from '@/mixins/vxe-table'

export default {
  name: 'pay-dialog',
  mixins: [VxeTable],
  data () {
    return {
      tableConfig: {
        autoHeight: false,
        footerColumn: ['totalAmount', 'payedAmount', 'unPayAmount', 'payAmount']
      },
      dataForm: {
        payType: '',
        payTime: ''
      },
      dataList: [],
      visible: false,
      validRules: {
        payType: [
          { required: true, message: '请填写付款方式' }
        ],
        payNo: [
          { required: true, message: '请填写付款凭证号' }
        ],
        payAmount: [
          { required: true, message: '请填写付款金额' }
        ]
      }
    }
  },
  methods: {
    batchSet () {
      this.dataList.forEach(row => {
        if (this.dataForm.payTime && !row.payTime) {
          row.payTime = this.dataForm.payTime
        }
        if (this.dataForm.payType && !row.payType) {
          row.payType = this.dataForm.payType
        }
      })
      this.dataForm.payTime = ''
      this.dataForm.payType = ''
    },
    updateFooterEvent () {
      const $table = this.$refs[this.tableConfig.tableName]
      $table.updateFooter()
    },
    init () {
      this.visible = true
    },
    dataFormSubmitHandle () {
      this.$refs[this.tableConfig.tableName].fullValidate(true, (errors) => {
        if (errors) {
          return
        }
        this.doSave()
      })
    },
    cancel () {
      this.visible = false
    },
    async doSave () {
      let postForm = [...this.dataList]
      const { data: res } = await this.$http.post(`/fund/pay/log/save`, postForm)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.$message.success('保存成功')
      this.$emit('complete')
      this.cancel()
    }
  }
}
</script>

<style scoped>

</style>
